module.exports = __webpack_public_path__ + "static/detectivepikachu-df80af1b69c58506355125862bc8699d.jpg";